import { rootStore } from '@yimoka/store';
export const useRoot = () => rootStore;
